import { defineStore } from 'pinia'

export const NavigationControls = defineStore('NavigationControls', {
    state: () => {
        return {
            show: false,
        }
    },

    getters: {
        visible: (state) => {
            return state.show
        }
    },

    actions: {
        open() {
            setTimeout(() => {
                this.show = true
            }, 100)
        },

        close() {
            this.show = false
        },

        toggle() {
            this.show = !this.show
        }
    }
})
